import React from 'react';
import {
  Container,
  FormField,
  Input,
  SpaceBetween,
  Textarea,
} from '@cloudscape-design/components';
import { QuestionFormParams } from '../QuestionFormWizard';
import DocumentLink from '../DocumentLink';
import { Question } from 'src/types/helios/Question';
import RequiredFieldLabel from 'src/components/RequiredFieldLabel';

interface DocumentationProps {
  formData: QuestionFormParams;
  setFormData: React.Dispatch<React.SetStateAction<QuestionFormParams>>;
  question?: Question;
  isCopyQuestion?: boolean;
  fieldValidationError: Record<string, string>;
}

const Documentation: React.FC<DocumentationProps> = ({
  formData,
  setFormData,
  question,
  isCopyQuestion = false,
  fieldValidationError,
}) => {
  return (
    <SpaceBetween size="l" data-testid="documentation-space-between">
      <DocumentLink
        data-testid="document-link"
        links={(formData.docLinks || []).map((doc) => ({
          heading: doc.title || 'Documentation',
          title: doc.title || '',
          url: doc.link || '',
        }))}
        onChange={(links) =>
          setFormData((prev) => ({
            ...prev,
            docLinks: links.map((link) => ({
              title: link.title || link.heading,
              link: link.url,
            })),
          }))
        }
      />
      {question && !isCopyQuestion && (
        <Container data-testid="change-summary-container">
          <FormField
            data-testid="change-summary-field"
            label={<RequiredFieldLabel label="Change Summary" />}
            errorText={fieldValidationError.changeLog}
            stretch
          >
            <Textarea
              data-testid="change-summary-textarea"
              value={formData.changeLog || ''}
              onChange={({ detail }) =>
                setFormData((prev) => ({
                  ...prev,
                  changeLog: detail.value,
                }))
              }
            />
          </FormField>
        </Container>
      )}
    </SpaceBetween>
  );
};

export default Documentation;
